import { DateRange } from "@angular/material/datepicker";
import { CustomerSearchType } from './customer-search.model';

export enum OrderByEnum {
  SELLTENANTID = "sellTenantId",
  DISPATCHTENANTID = "dispatchTenantId",
  REQUESTREASONID = "requestReasonId",
  CUSTOMERDOCUMENT = "customerDocument",
  CREATEDAT = "createdAt",
  TIMESTARTEDAT = "timeStartedAt"
}

export enum SortOrderEnum {
  DESC = "DESC",
  ASC = "ASC",
}

export enum RequestTabEnum {
	MONITORED_BY_ME = "MONITORED_BY_ME",
  ASSIGNED_ME = "ASSIGNED_ME",
  DEFAULT = "DEFAULT",
}

export class RequestSearch {
	searchValue?: string;
	requestStatus?: number[];
	slaStatus?: string|string[];
	providerSlaStatus?: string;
	managementSlaStatus?: string;
	dateType?: any;
  dateRange?: DateRange<Date>;
	dateFrom?: Date;
	dateTo?: Date;
	priority?: string|string[];
	sellTenantId?: string|string[];
	requestReasonIds?: number|number[];
	dispatchTenantId?: string|string[];
	recontact?: any;
	labels?: string[];
	limit?: number;
	offset?: number;
	requestTab?: RequestTabEnum;
	orderBy?: OrderByEnum;
	sortOrder?: SortOrderEnum;
}
